import React, { Component } from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import SimpleBox from '../../../../partials/content/SimpleBox';
import PortletSpinner from '../../../../partials/layout/PortletSpinner';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import * as contractsCrud from "../../../../crud/contracts.crud";
import DataGrid, { Editing, Paging } from 'devextreme-react/data-grid';
import * as tagCrud from '../../../../crud/tag.crud';

class CompanySecurityGroups extends Component {
  constructor(props){
    super(props);
    this.contractTagsEnabled = process.env.REACT_APP_CONTRACT_COMPANY_TAGS_ENABLED === 'true';
  }
  state = {
    securityGroupUsers: null,
    securityGroupName: null,
    contractTags: null
  }
  componentDidMount() {
    this.setTags();
  }
  setTags = async (companyid) => {
    if (!this.contractTagsEnabled) { return; }
    try {
      const { data: contractTags } = await tagCrud.GetTagsForCategory(["SecurityGroups"],this.props.company.companyid);
      this.setState({ contractTags });

    } catch (err) {
      this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
    }
  }
  fetchSecurityGroupUsers = (securityGroupId) => {
    contractsCrud.getContractSecurityGroupUserList(this.props.company.companyid, securityGroupId, null)
      .then(response => {
        const securityGroupUsers = response.data.aggregatelist;
        this.setState({ securityGroupUsers });
      })
      .catch(err => {
        this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
      });
  }

  onValueChanged = (field, value) => {
    if (field === "securitygroupid") {
      let securityGroupName = this.state.contractTags.filter(tag => tag.tagid === value)[0].name;
      this.setState({ securityGroupName }, () => {
        this.fetchSecurityGroupUsers(value);
      });
    }
  };

  handleSubmit = (securityGroup, setSubmitting, clearForm) => {
    contractsCrud.createContractSecurityGroupUser(securityGroup)
      .then(() => {
        this.props.enqueueSnackbar('User successfully added', { variant: 'success', });
        setSubmitting(false);
        clearForm();
        this.fetchSecurityGroupUsers(securityGroup.securitygroupid);
      })
      .catch(err => {
        this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        setSubmitting(false);
      });
  }

  onRowRemoved = (rowdata) => {
    const securityGroup = { ...rowdata.data };
    securityGroup.deleted = 1;
    contractsCrud.createContractSecurityGroupUser(securityGroup)
      .then(() => {
        this.props.enqueueSnackbar('User successfully deleted', { variant: 'success', });
        this.fetchSecurityGroupUsers(securityGroup.securitygroupid);
      })
      .catch(err => {
        this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
      });
  }

  render() {
    if (!this.state.contractTags) {
      return (<PortletSpinner />);
    }

    var companyUsers = this.props.companyUsers ? this.props.companyUsers.filter(user => user.deleted === 0 && user.type === 'View Security Groups') : null;

    if (this.state.securityGroupUsers && this.state.securityGroupUsers.length > 0 && companyUsers && companyUsers.length > 0) {
      companyUsers = companyUsers.filter(user => !this.state.securityGroupUsers.some(securityGroupUser => user.accountid === securityGroupUser.userid));
    }

    const newSecurityGroupFormConfig = {
      buttonText: 'Add User to Security Group',
      fields: [
        {
          label: 'Add New User to Security Group',
          fields: [
            { label: 'Select Security Group', dataField: 'securitygroupid', editorType: 'dxSelectBox', editorOptions: { dataSource: this.state.contractTags, valueExpr: 'tagid', displayExpr: 'name' } },
            { label: 'Select User', dataField: 'userid', editorType: 'dxSelectBox', editorOptions: { dataSource: companyUsers, valueExpr: 'accountid', displayExpr: 'name' } },
          ]
        }
      ]
    };

    const simpleBoxTitle = this.state.securityGroupName ? `${this.state.securityGroupName} Users List` : 'Security Group Users List';

    return (
      <Portlet>
        <PortletHeader title="Security Group Users" />
        <PortletBody>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '10px' }}>
            <BiDynamicForm
              config={newSecurityGroupFormConfig}
              valueChangeHandler={this.onValueChanged}
              onSubmitHandler={this.handleSubmit}
            />
          </div>
          <div style={{ height: 20 }} />
          <SimpleBox title={simpleBoxTitle}>
            <DataGrid
              version="1"
              height={470}
              hoverStateEnabled={true}
              rowAlternationEnabled={true}
              showBorders={true}
              showColumnLines={true}
              showRowLines={true}
              remoteOperations={false}
              allowColumnReordering={true}
              columnResizingMode='widget'
              name="Security Group Users"
              dataSource={this.state.securityGroupUsers}
              keyExpr="contractsecuritygroupuserid"
              onRowRemoved={this.onRowRemoved}
              columns={[
                { caption: "User Name", dataField: "user" },
              ]}
            >
              <Editing
                mode="row"
                allowUpdating={false}
                allowDeleting={true}
                allowAdding={false}
                texts={{ deleteRow: "Delete" }}
              />
              <Paging pageSize={10} defaultPageSize={10} defaultPageIndex={0} />
            </DataGrid>
          </SimpleBox>
        </PortletBody>
      </Portlet>
    );
  }
}

const mapStateToProps = store => ({
  company: store.company.company,
  companyUsers: store.company.companyUsers,
  userProfile: store.auth.userProfile,
});

export default withSnackbar(connect(mapStateToProps)(CompanySecurityGroups));